import { Icon } from "@chakra-ui/react";
import React from "react";

export const CategoriesIcon = (props: any) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 3H4C3.447 3 3 3.447 3 4V10C3 10.553 3.447 11 4 11H10C10.553 11 11 10.553 11 10V4C11 3.447 10.553 3 10 3ZM9 9H5V5H9V9ZM20 3H14C13.447 3 13 3.447 13 4V10C13 10.553 13.447 11 14 11H20C20.553 11 21 10.553 21 10V4C21 3.447 20.553 3 20 3ZM19 9H15V5H19V9ZM10 13H4C3.447 13 3 13.447 3 14V20C3 20.553 3.447 21 4 21H10C10.553 21 11 20.553 11 20V14C11 13.447 10.553 13 10 13ZM9 19H5V15H9V19ZM17 13C14.794 13 13 14.794 13 17C13 19.206 14.794 21 17 21C19.206 21 21 19.206 21 17C21 14.794 19.206 13 17 13ZM17 19C15.897 19 15 18.103 15 17C15 15.897 15.897 15 17 15C18.103 15 19 15.897 19 17C19 18.103 18.103 19 17 19Z"
      fill="currentColor"
    />
  </Icon>
);
